module.exports = __webpack_public_path__ + "static/media/motivation.42029a7b.svg";